<script setup lang="ts">
import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';

const props = defineProps<{
  class?: HTMLAttributes['class'];
  testId?: string;
}>();
</script>

<template>
  <section
    :data-testid="props.testId"
    :class="
      cn('rounded-xl border border-gray-200 bg-white shadow-sm', props.class)
    "
  >
    <slot />
  </section>
</template>
